import { columnsContractsType } from "pages/contracts-pages/types/columsContract.types";
import { columnsUsersType } from "pages/user-provider-management/types/columsUsers.types";
import { IElectronicDocuments } from "shared/models";

export const convertUsersProviders = (data: any): IElectronicDocuments => {
  const content = () => {
    return data?.content?.map(({ personalInfo }: any): columnsUsersType => {
      return {
        organizationCode: personalInfo?.organizationCode || "",
        employerIdNumber: personalInfo?.employerIdNumber || "",
        natureIdentification: {
          name: personalInfo?.type || "",
          id: personalInfo?.typeId || 0,
        },
        givenName: personalInfo?.givenName || "",
        acreedor: personalInfo?.companyMatchCode || "",
        region: {
          name: personalInfo?.address?.region || "",
          id: personalInfo?.address?.regionId || 0,
        },
        locality: {
          name: personalInfo?.address?.locality || "",
          id: personalInfo?.address?.localityId || 0,
        },
        streetAddress: personalInfo?.address?.streetAddress || "",
        email: personalInfo?.email || "",
        emailTwo: personalInfo?.email2 || "",
        phoneNumberOne: personalInfo?.phoneNumber
          ? personalInfo?.phoneNumber
          : "",
        phoneNumberTwo: personalInfo?.phoneNumberTwo
          ? personalInfo?.phoneNumberTwo
          : "",
        contactPersonOne: personalInfo?.contactPersonOne || "",
        contactPersonTwo: personalInfo?.contactPersonTwo || "",
        contactPersonOccupationOne:
          personalInfo?.contactPersonOccupationOne || "",
        contactPersonOccupationTwo:
          personalInfo?.contactPersonOccupationTwo || "",
        id: personalInfo?.id || 0,
      };
    });
  };

  return {
    content: content(),
    totalElements: data.totalElements,
    number: data.number,
    size: data.size,
    contentSize: data.contentSize,
  };
};
